import { Link } from "react-router-dom";
import { useContent } from "../context/ContentContext";

export function Brand({ compact = false }: { compact?: boolean }) {
  const { branding } = useContent().content;
  return (
    <Link to="/" className="brand" aria-label="TTC Rehlingen – Startseite">
      <span className={`brand-mark ${branding.logo ? "brand-mark--image" : ""}`} aria-hidden={!branding.logo}>
        {branding.logo ? <img src={branding.logo} alt={branding.logoAlt || "Vereinslogo des TTC Rehlingen"} /> : <><span className="brand-paddle" /><span className="brand-ball" /></>}
      </span>
      {!compact && (
        <span className="brand-copy">
          <strong>TTC Rehlingen</strong>
          <small>seit 1964</small>
        </span>
      )}
    </Link>
  );
}
